import { render, staticRenderFns } from "./base.vue?vue&type=template&id=0ca2f859&scoped=true"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"
import style0 from "./base.vue?vue&type=style&index=0&id=0ca2f859&prod&lang=css"
import style1 from "./base.vue?vue&type=style&index=1&id=0ca2f859&prod&lang=css"
import style2 from "./base.vue?vue&type=style&index=2&id=0ca2f859&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca2f859",
  null
  
)

export default component.exports